import script from "./SmartPhoneOrderBook.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartPhoneOrderBook.vue?vue&type=script&setup=true&lang=ts"

import "./SmartPhoneOrderBook.vue?vue&type=style&index=0&id=a11e18c8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a11e18c8"]])

export default __exports__